import { render, staticRenderFns } from "./ArticleSelectLang.vue?vue&type=template&id=590f9deb"
import script from "./ArticleSelectLang.vue?vue&type=script&lang=js"
export * from "./ArticleSelectLang.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports